import React from "react";

// TIA wordmark — three letters interlocked, "I" sits centred & shorter between T & A
export const Logo = ({ size = "md", showWordmark = true }) => {
  const monoSize = size === "lg" ? "text-5xl" : size === "sm" ? "text-2xl" : "text-3xl";
  const wordSize = size === "lg" ? "text-[10px]" : "text-[9px]";
  // In the sticky Nav (size="sm"), suppress wordmark on phones to avoid overlapping
  // the side nav links on a 64px header. Footer / Home keep the full wordmark.
  const wordmarkVisibility = size === "sm" ? "hidden md:flex" : "flex";
  return (
    <div className="flex flex-col items-center leading-none select-none" data-testid="brand-logo">
      <div className={`font-display ${monoSize} text-[#1a1814] tracking-[0.02em] flex items-baseline`}>
        <span>T</span>
        <span className="mx-[-0.04em] relative -top-[0.02em] text-[0.92em]">I</span>
        <span className="-ml-[0.06em]">A</span>
      </div>
      {showWordmark && (
        <div className={`${wordmarkVisibility} flex-col items-center mt-1.5`}>
          <div className={`micro-label text-[#1a1814] ${wordSize}`}>The Identity</div>
          <div className="h-px w-3 bg-[#1a1814] my-1" />
          <div className={`micro-label text-[#1a1814] ${wordSize}`}>Atelier</div>
        </div>
      )}
    </div>
  );
};
